(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-autores"] && !Shopify.designMode) return;
  try {
    
  function inicializarCarruselAutores() {
    document.querySelectorAll('.carruselautores-seccion').forEach(function (seccion) {
      if (seccion.dataset.carruselListo === 'true') return;
      seccion.dataset.carruselListo = 'true';

      var slides = seccion.querySelectorAll('.carruselautores-slide');
      var puntos = seccion.querySelectorAll('.carruselautores-punto');
      var flechaPrev = seccion.querySelector('.carruselautores-flecha--prev');
      var flechaNext = seccion.querySelector('.carruselautores-flecha--next');
      var indiceActual = 0;
      var temporizador = null;
      var autoplayActivo = seccion.dataset.autoplay === 'true';
      var velocidad = parseInt(seccion.dataset.velocidad, 10) || 5000;
      var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length < 2) return;

      function mostrarSlide(indice) {
        slides.forEach(function (slide) {
          slide.classList.remove('carruselautores-slide--activo');
        });
        puntos.forEach(function (punto) {
          punto.classList.remove('carruselautores-punto--activo');
        });
        slides[indice].classList.add('carruselautores-slide--activo');
        if (puntos[indice]) {
          puntos[indice].classList.add('carruselautores-punto--activo');
        }
        indiceActual = indice;
      }

      function irSiguiente() {
        var siguiente = (indiceActual + 1) % slides.length;
        mostrarSlide(siguiente);
      }

      function irAnterior() {
        var anterior = (indiceActual - 1 + slides.length) % slides.length;
        mostrarSlide(anterior);
      }

      function iniciarAutoplay() {
        if (!autoplayActivo || reducirMovimiento) return;
        detenerAutoplay();
        temporizador = setInterval(irSiguiente, velocidad);
      }

      function detenerAutoplay() {
        if (temporizador) {
          clearInterval(temporizador);
          temporizador = null;
        }
      }

      if (flechaNext) {
        flechaNext.addEventListener('click', function () {
          irSiguiente();
          iniciarAutoplay();
        });
      }

      if (flechaPrev) {
        flechaPrev.addEventListener('click', function () {
          irAnterior();
          iniciarAutoplay();
        });
      }

      puntos.forEach(function (punto) {
        punto.addEventListener('click', function () {
          var indice = parseInt(punto.getAttribute('data-punto-index'), 10);
          mostrarSlide(indice);
          iniciarAutoplay();
        });
      });

      seccion.addEventListener('mouseenter', detenerAutoplay);
      seccion.addEventListener('mouseleave', iniciarAutoplay);

      iniciarAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', inicializarCarruselAutores);
  document.addEventListener('shopify:section:load', inicializarCarruselAutores);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contador-catalogo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tiempoRelativoEnEspanol(segundosPublicacion) {
      var ahoraSegundos = Math.floor(Date.now() / 1000);
      var diferencia = ahoraSegundos - segundosPublicacion;

      if (diferencia < 60) {
        return 'hace instantes';
      }

      var minutos = Math.floor(diferencia / 60);
      if (minutos < 60) {
        return 'hace ' + minutos + (minutos === 1 ? ' minuto' : ' minutos');
      }

      var horas = Math.floor(minutos / 60);
      if (horas < 24) {
        return 'hace ' + horas + (horas === 1 ? ' hora' : ' horas');
      }

      var dias = Math.floor(horas / 24);
      if (dias < 30) {
        return 'hace ' + dias + (dias === 1 ? ' día' : ' días');
      }

      var meses = Math.floor(dias / 30);
      if (meses < 12) {
        return 'hace ' + meses + (meses === 1 ? ' mes' : ' meses');
      }

      var anios = Math.floor(dias / 365);
      return 'hace ' + anios + (anios === 1 ? ' año' : ' años');
    }

    function actualizarTiemposRelativos(contenedor) {
      var elementosTiempo = contenedor.querySelectorAll('[data-contadorcatalogo-tiempo]');
      elementosTiempo.forEach(function (elemento) {
        var epoch = parseInt(elemento.getAttribute('data-contadorcatalogo-epoch'), 10);
        if (!isNaN(epoch) && epoch > 0) {
          elemento.textContent = tiempoRelativoEnEspanol(epoch);
        }
      });
    }

    function detenerDesplazamiento(track) {
      if (track._contadorcatalogoRafId) {
        cancelAnimationFrame(track._contadorcatalogoRafId);
        track._contadorcatalogoRafId = null;
      }
      track.style.transform = '';
    }

    function iniciarDesplazamiento(track, duracionSegundos) {
      if (track._contadorcatalogoRafId) return;

      var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducirMovimiento) return;

      var anchoUnaVuelta = track.scrollWidth / 2;
      if (!anchoUnaVuelta || anchoUnaVuelta <= 0) return;

      var pixelesPorMs = anchoUnaVuelta / (duracionSegundos * 1000);
      var posicion = 0;
      var ultimoTiempo = null;

      function paso(tiempoActual) {
        if (ultimoTiempo === null) {
          ultimoTiempo = tiempoActual;
        }
        var delta = tiempoActual - ultimoTiempo;
        ultimoTiempo = tiempoActual;

        posicion -= pixelesPorMs * delta;
        if (posicion <= -anchoUnaVuelta) {
          posicion += anchoUnaVuelta;
        }

        track.style.transform = 'translateX(' + posicion + 'px)';
        track._contadorcatalogoRafId = requestAnimationFrame(paso);
      }

      track._contadorcatalogoRafId = requestAnimationFrame(paso);
    }

    function evaluarDesplazamiento(contenedor) {
      var marquee = contenedor.querySelector('.contadorcatalogo-marquee');
      var track = contenedor.querySelector('.contadorcatalogo-marquee-track');
      var primerItem = contenedor.querySelector('.contadorcatalogo-item:not([aria-hidden])');
      if (!marquee || !track || !primerItem) return;

      var anchoDisponible = marquee.clientWidth;
      var anchoNecesario = primerItem.scrollWidth;
      var deberiaDesplazarse = anchoNecesario > anchoDisponible;
      var yaTieneClase = track.classList.contains('contadorcatalogo-desplazar');

      if (deberiaDesplazarse === yaTieneClase) return;

      if (deberiaDesplazarse) {
        track.classList.add('contadorcatalogo-desplazar');
        var duracionSegundos = parseFloat(track.style.getPropertyValue('--contadorcatalogo-velocidad')) || 18;
        requestAnimationFrame(function () {
          iniciarDesplazamiento(track, duracionSegundos);
        });
      } else {
        track.classList.remove('contadorcatalogo-desplazar');
        detenerDesplazamiento(track);
      }
    }

    function inicializarContadorCatalogo(contenedor) {
      actualizarTiemposRelativos(contenedor);
      evaluarDesplazamiento(contenedor);

      setInterval(function () {
        actualizarTiemposRelativos(contenedor);
      }, 60000);

      var marquee = contenedor.querySelector('.contadorcatalogo-marquee');
      if (marquee && 'ResizeObserver' in window) {
        var anchoAnterior = marquee.clientWidth;
        var observador = new ResizeObserver(function (entradas) {
          var anchoNuevo = entradas[0].contentRect.width;
          if (Math.abs(anchoNuevo - anchoAnterior) < 5) return;
          anchoAnterior = anchoNuevo;
          evaluarDesplazamiento(contenedor);
        });
        observador.observe(marquee);
      } else {
        var reevaluarConDemora;
        window.addEventListener('resize', function () {
          clearTimeout(reevaluarConDemora);
          reevaluarConDemora = setTimeout(function () {
            evaluarDesplazamiento(contenedor);
          }, 300);
        });
      }

      document.addEventListener('visibilitychange', function () {
        var track = contenedor.querySelector('.contadorcatalogo-marquee-track');
        if (!track) return;
        if (document.hidden) {
          detenerDesplazamiento(track);
          track.classList.remove('contadorcatalogo-desplazar');
        } else {
          evaluarDesplazamiento(contenedor);
        }
      });
    }

    document.querySelectorAll('.contadorcatalogo-barra').forEach(function (contenedor) {
      inicializarContadorCatalogo(contenedor);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-autor"]) return;
  try {
    
  (function () {
    var elementosAnimados = document.querySelectorAll('.paginaautor-animar');
    if (!elementosAnimados.length) return;

    if (!('IntersectionObserver' in window)) {
      elementosAnimados.forEach(function (elemento) {
        elemento.classList.add('paginaautor-visible');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('paginaautor-visible');
            observador.unobserve(entrada.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elementosAnimados.forEach(function (elemento) {
      observador.observe(elemento);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pestanas-coleccion"] && !Shopify.designMode) return;
  try {
    
  function inicializarPestanasColeccion() {
    document.querySelectorAll('.pestanas-coleccion-seccion').forEach(function (seccion) {
      if (seccion.dataset.pestanasListo === 'true') return;
      seccion.dataset.pestanasListo = 'true';

      var tabs = seccion.querySelectorAll('.pestanas-coleccion-tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-pestana-target');
          var targetPanel = seccion.querySelector('#' + targetId);
          if (!targetPanel) return;

          tabs.forEach(function (otro) {
            otro.classList.remove('pestanas-coleccion-tab--activa');
            otro.setAttribute('aria-selected', 'false');
          });
          seccion.querySelectorAll('.pestanas-coleccion-panel').forEach(function (panel) {
            panel.classList.remove('pestanas-coleccion-panel--activo');
          });

          tab.classList.add('pestanas-coleccion-tab--activa');
          tab.setAttribute('aria-selected', 'true');
          targetPanel.classList.add('pestanas-coleccion-panel--activo');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', inicializarPestanasColeccion);
  document.addEventListener('shopify:section:load', inicializarPestanasColeccion);

  } catch(e) { console.error(e); }
})();
})();
